export const specialtyLabel = (value) => {
  const map = {
    GENERAL: "General",
    ORTODONCIA: "Ortodoncia",
    ENDODONCIA: "Endodoncia",
    CIRUGIA: "Cirugía",
    IMPLANTOLOGIA: "Implantología",
    PROSTODONCIA: "Prostodoncia",
    PERIODONCIA: "Periodoncia",
    PEDIATRIA: "Odontopediatría"
  }
  return map[value] || "Sin especialidad"
}

export const minutesBetweenSafe = (start, end) => {
  if (!start || !end) return 0

  const s = new Date(start)
  const e = new Date(end)

  if (isNaN(s.getTime()) || isNaN(e.getTime())) return 0

  const diff = e.getTime() - s.getTime()

  if (diff <= 0) return 0

  return Math.floor(diff / 60000)
}

export const calculateIdleTime = (events = []) => {
  if (!events.length) return 0

  const sorted = [...events]
    .filter(e => e.start && e.end)
    .sort((a, b) => new Date(a.start) - new Date(b.start))

  let idle = 0

  for (let i = 0; i < sorted.length - 1; i++) {
    const currentEnd = sorted[i].end
    const nextStart = sorted[i + 1].start

    idle += minutesBetweenSafe(currentEnd, nextStart)
  }

  return idle
}

export const statusLabel = (value) => {
  const map = {
    SCHEDULED: "Programada",
    HELD: "Reservada",
    CONFIRMED: "Confirmada",
    COMPLETED: "Completada",
    CANCELLED: "Cancelada",
    ACTIVE: "Pendiente / presente"
  }
  return map[value] || value || "Sin estado"
}

export const planItemStatusLabel = (value) => {
  const map = {
    PENDING: "Pendiente",
    SCHEDULED: "Agendado",
    IN_PROGRESS: "En progreso",
    DONE: "Realizado",
    CANCELLED: "Cancelado"
  }
  return map[value] || value || "Sin estado"
}

export const formatMoney = (value) => {
  return Number(value || 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 2
  })
}

export const formatDateTimeLocal = (value) => {
  if (!value) return ""
  const d = new Date(value)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  const hours = String(d.getHours()).padStart(2, "0")
  const minutes = String(d.getMinutes()).padStart(2, "0")
  return `${year}-${month}-${day}T${hours}:${minutes}`
}

export const formatDateTime = (value) => {
  if (!value) return "-"
  return new Date(value).toLocaleString("es-MX")
}

export const getTodayLocal = () => {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, "0")
  const d = String(now.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}